// extracted by mini-css-extract-plugin
module.exports = {"steps_container":"documents_steps_container__1-na_","steps":"documents_steps__vNA9J","steps_list":"documents_steps_list__XZm45"};